import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import styled from "styled-components";

// XCentium override to change Accordion colors

export type AccordionSectionPanelProps = MobiusStyledComponentProps<"dd", InjectableCss>;

const AccordionSectionPanel = styled.dd`
    margin: 0;
    padding-left: 2px;
    border-top: 0;
    display: ${({ hidden }) => (hidden ? "none" : "block")};
    ${injectCss}
`;

export default AccordionSectionPanel;
